import { signal } from "@angular/core";

export interface ActiveMenuComponent {
    isActive: () => boolean;
}

export const activeMenu = signal<ActiveMenuComponent | undefined>(undefined);
